// HH:mm:ss
export function formatSecondToMinute(
  seconds: number,
  format: string,
) {
  const minutes = Math.floor(seconds / 60) || 0;
  const newSeconds = Math.floor(seconds % 60) || 0;
  const minutesStr = `${minutes < 10 ? '0' : ''}${minutes}`;
  const newSecondsStr = `${newSeconds < 10 ? '0' : ''}${newSeconds}`;
  return format.replace(/mm/i, minutesStr).replace(/ss/i, newSecondsStr);
}

export const formatMillisecondToHour = (
  millisecond: number,
  format: string,
) => {
  if (!millisecond) {
    return millisecond;
  }
  const seconds = millisecond / 1000;
  const hours = Math.floor(seconds / 3600) || 0;
  const minutes = Math.floor((seconds % 3600) / 60) || 0;
  const newSeconds = Math.floor(seconds % 60) || 0;

  const hoursStr = `${hours < 10 ? '0' : ''}${hours}`;
  const minutesStr = `${minutes < 10 ? '0' : ''}${minutes}`;
  const newSecondsStr = `${newSeconds < 10 ? '0' : ''}${newSeconds}`;

  return format
    .replace(/hh/i, hoursStr)
    .replace(/mm/i, minutesStr)
    .replace(/ss/i, newSecondsStr);
};
